import { Store, MutationPayload } from 'vuex';
import { ProductShoppingListSection } from '@/components/tabs/components/product-shopping-list/ProductShoppingList';
import { IRootState } from '../mxr-store/state';
import {
    UPDATE_PRODUCT_SHOPPING_LIST_SECTIONS,
    SET_MXR_RETAILER_OFFERS,
    SET_MXR_CONFIG, PREV_CARD,
    NEXT_CARD,
    UPDATE_VISIBLE_PROMOTION_IDS,
    GET_SHOPPING_LIST,
    GET_PROMOTIONS,
    GET_VISIBLE_PROMOTION_UNIQUE_IDS,
} from '../types';

export const productSectionPlugin = (store: Store<IRootState>) => {
    store.subscribe((mutation: MutationPayload) => {
        const cardEvents = [SET_MXR_CONFIG, SET_MXR_RETAILER_OFFERS as string, NEXT_CARD, PREV_CARD];
        const promotionEvents = [UPDATE_VISIBLE_PROMOTION_IDS as string];
        if (cardEvents.indexOf(mutation.type) >= 0) {
            const sections: ProductShoppingListSection[] = [];
            if (!store.getters[GET_SHOPPING_LIST]) {
                return;
            }
            store.getters[GET_SHOPPING_LIST].map(ProductShoppingListSection.createFromShoppingListCategory)
                .forEach((i: ProductShoppingListSection) => sections.push(i));
            store.commit(UPDATE_PRODUCT_SHOPPING_LIST_SECTIONS, sections);
        } else if (promotionEvents.indexOf(mutation.type) >= 0) {
            const sections: ProductShoppingListSection[] = [];
            if (!store.getters[GET_PROMOTIONS]) {
                return;
            }
            store.getters[GET_PROMOTIONS]
                .map(ProductShoppingListSection.createFromCarousel)
                .forEach((s: ProductShoppingListSection) => {
                    // s.Items = s.Items.filter(i => store.state.visiblePromotionIds.indexOf(i.Id) >= 0);
                    s.Items = s.Items.filter(i => store.getters[GET_VISIBLE_PROMOTION_UNIQUE_IDS].indexOf(i.UniqueId) >= 0);
                    sections.push(s);
                });
            store.commit(UPDATE_PRODUCT_SHOPPING_LIST_SECTIONS, sections);
        }
    });
};
